export default __webpack_public_path__ + "static/Swiss721BT-Roman-8f9db6f40f6c5e39c0597609f2305e79.woff2";